import { Component, ChangeDetectionStrategy } from '@angular/core'
import { RouterOutlet } from '@angular/router'

@Component({
    selector: 'sq-public',
    imports: [RouterOutlet],
    templateUrl: './public-layout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './public-layout.component.scss',
})
export class PublicComponent {}
